var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "nearmissTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          tabItems: _vm.tabItems,
          height: _vm.tabHeight,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    tabParam: _vm.tabParam,
                    grid: _vm.grid,
                    imprTabInfo: _vm.imprTabInfo,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:grid": function ($event) {
                      _vm.grid = $event
                    },
                    "update:imprTabInfo": function ($event) {
                      _vm.imprTabInfo = $event
                    },
                    "update:impr-tab-info": function ($event) {
                      _vm.imprTabInfo = $event
                    },
                    closePopup: _vm.closePopup,
                    changeStatus: _vm.changeStatus,
                    getDetail: _vm.getDetail,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }